(() => {
  const initializeCarousel = (carousel) => {
    if (!carousel || carousel.dataset.weeklyDealsInitialized === 'true') {
      return;
    }

    const track = carousel.querySelector('.weekly-deals-v2__track');
    const previousButton = carousel.querySelector('.weekly-deals-v2__prev');
    const nextButton = carousel.querySelector('.weekly-deals-v2__next');

    if (!track || !previousButton || !nextButton) return;

    carousel.dataset.weeklyDealsInitialized = 'true';

    let resizeTimer;

    const updateArrowVisibility = () => {
      const scrollLeft = Math.max(0, track.scrollLeft);
      const maximumScroll = Math.max(
        0,
        track.scrollWidth - track.clientWidth
      );

      previousButton.hidden = scrollLeft <= 8;
      nextButton.hidden =
        maximumScroll <= 8 || scrollLeft >= maximumScroll - 8;
    };

    const scrollTrack = (direction) => {
      const reduceMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      track.scrollBy({
        left: direction * 380,
        behavior: reduceMotion ? 'auto' : 'smooth'
      });
    };

    previousButton.addEventListener('click', () => scrollTrack(-1));
    nextButton.addEventListener('click', () => scrollTrack(1));

    track.addEventListener('scroll', updateArrowVisibility, {
      passive: true
    });

    window.addEventListener(
      'resize',
      () => {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(updateArrowVisibility, 150);
      },
      { passive: true }
    );

    window.requestAnimationFrame(updateArrowVisibility);
  };

  const initializeAll = (scope = document) => {
    if (scope.matches?.('.weekly-deals-v2__carousel')) {
      initializeCarousel(scope);
    }

    scope
      .querySelectorAll?.('.weekly-deals-v2__carousel')
      .forEach(initializeCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), {
      once: true
    });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
